export default __webpack_public_path__ + "static/el_proyecto-88d201144d6f5cde539c423bb8ccc101.png";